import { ITimelineFilter } from "../interfaces/i-timeline-filter";
import { ITypeFilter } from "../interfaces/i-type-filter";

export const TimelineFilter: (
  modeTypes?: ITypeFilter[],
  resolutions?: ITypeFilter[],
  orthoStatus?: ITypeFilter[],
  imageryTypes?: ITypeFilter[],
  layerTypes?: ITypeFilter[],
) => ITimelineFilter = (
  modeTypes: ITypeFilter[],
  resolutions: ITypeFilter[],
  orthoStatus: ITypeFilter[],
  imageryTypes: ITypeFilter[],
  layerTypes: ITypeFilter[],
) => ({
  modeTypes,
  resolutions,
  orthoStatus,
  imageryTypes,
  layerTypes,
  isEnabled: () => {
    return (
      modeTypes?.some((i) => !i.checked) ||
      resolutions?.some((i) => !i.checked) ||
      orthoStatus?.some((i) => !i.checked) ||
      imageryTypes?.some((i) => !i.checked) ||
      layerTypes?.some((i) => !i.checked)
    );
  },
  is3D: () => {
    console.log("timeline filter method: is3D");
    return modeTypes[modeTypes.findIndex((m) => m.value === "3D")]?.checked;
  },
  is2D: () => {
    console.log("timeline filter method: is2D");
    return modeTypes[modeTypes.findIndex((m) => m.value === "2D")]?.checked;
  },
  getResolutions: () => {
    console.log("timeline filter method: getResolutions");
    return resolutions.map((r) => r.value);
  },
  isTrueOrtho: () => {
    console.log("timeline filter method: isTrueOrtho");
    return orthoStatus[orthoStatus.findIndex((m) => m.value === "trueOrtho")]?.checked;
  },
  isOrtho: () => {
    console.log("timeline filter method: isOrtho");
    return orthoStatus[orthoStatus.findIndex((m) => m.value === "ortho")]?.checked;
  },
  isBluesky: () => {
    console.log("timeline filter method: isBluesky");
    return imageryTypes[imageryTypes.findIndex((m) => m.value === "bluesky")]?.checked;
  },
  isGraysky: () => {
    console.log("timeline filter method: isGraysky");
    return imageryTypes[imageryTypes.findIndex((m) => m.value === "graysky")]?.checked;
  },
  isUrbanLayer: () => {
    console.log("timeline filter method: isUrbanLayer");
    return layerTypes[layerTypes.findIndex((m) => m.value === "urban" || m.value === "urban-g")]?.checked;
  },
  isUrbanRLayer: () => {
    console.log("timeline filter method: isUrbanRLayer");
    return layerTypes[layerTypes.findIndex((m) => m.value === "urban-r")]?.checked;
  },
  isWideAreaLayer: () => {
    console.log("timeline filter method: isWideAreaLayer");
    return layerTypes[layerTypes.findIndex((m) => m.value === "wide-area")]?.checked;
  },
  isGrayskyLayer: () => {
    console.log("timeline filter method: isGrayskyLayer");
    return layerTypes[layerTypes.findIndex((m) => m.value === "graysky" || m.value === "graysky-g")]?.checked;
  },
});
